import { ProjectionFilters, ProjectionPFFilters } from "app/utils/types";
import { getHeaderText } from "./projectionSDColumnJson";
import { getUSANumberFormat } from "../utils/utils";

export const projectionColumnJson: any = (
  selectedProjectionData: any,
  selectedChartFilter: any,
) => [
  {
    field: selectedChartFilter || "planYear",
    header: getHeaderText(selectedChartFilter),
    frozen: true,
  },
  {
    field: "businessValuation",
    header: "Shareholder Value",
    style: {
      opacity: !selectedProjectionData?.includes(ProjectionFilters.BUSINESS_VALUE) ? 0.5 : 1,
    },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "annualGrowthRate",
    header: "Annual Growth Rate Projection",
    formatter: (value: any) => `${value || 0}%`, // Using template literals
  },
  {
    field: "deathBenefit",
    header: "Death Benefit",
    style: {
      opacity: !selectedProjectionData?.includes(ProjectionFilters.DEATH_BENEFIT) ? 0.5 : 1,
    },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "disabilityBenefit",
    header: "Disability Benefit",
    style: {
      opacity: !selectedProjectionData?.includes(ProjectionFilters.DISABILITY_BENEFIT) ? 0.5 : 1,
    },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
];
export const headerColumnGroupProjection = {
  VALUATIONS: ["businessValuation", "annualGrowthRate"],
  "SHAREHOLDER BENEFITS": ["disabilityBenefit", "deathBenefit"],
};

export const projectionPFColumnJson: any = (
  selectedProjectionData: any,
  selectedChartFilter: any,
) => [
  {
    field: selectedChartFilter || "planYear",
    header: getHeaderText(selectedChartFilter),
    frozen: true,
  },
  {
    field: "illustratedPlanAccumulatedValue",
    header: "Illustrated Plan Accumulated Value",
    style: {
      opacity: !selectedProjectionData?.includes(ProjectionPFFilters.ACCUMULATED_VALUE) ? 0.5 : 1,
    },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "illustratedPlanSurrenderValue",
    header: "Illustrated Plan Surrender Value",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
    style: {
      opacity: !selectedProjectionData?.includes(ProjectionPFFilters.CASH_VALUE) ? 0.5 : 1,
    },
  },
  {
    field: "stressedCashValue",
    header: "Illustrated Plan Stress Surrender Value",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
    style: {
      opacity: !selectedProjectionData?.includes(ProjectionPFFilters.STRESSED_CASH_VALUE) ? 0.5 : 1,
    },
  },
  {
    field: "illustratedPlanDB",
    header: "Illustrated Plan DB",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
    style: {
      opacity: !selectedProjectionData?.includes(ProjectionPFFilters.DEATH_BENEFIT) ? 0.5 : 1,
    },
  },
  {
    field: "estimatedLoanPayoffOrIncome",
    header: "Estimated Income",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
    style: {
      opacity: !selectedProjectionData?.includes(ProjectionPFFilters.ANNUAL_INCOME) ? 0.5 : 1,
    },
  },
  {
    field: "totalIncome",
    header: "Total Income",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
    style: {
      opacity: !selectedProjectionData?.includes(ProjectionPFFilters.TOTAL_INCOME) ? 0.5 : 1,
    },
  },
  {
    field: "outsideCollateralRequirement",
    header: "Outside Collateral Requirement",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "lenderPremium",
    header: "Financed Premium",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
    style: {
      opacity: !selectedProjectionData?.includes(ProjectionPFFilters.LOAN) ? 0.5 : 1,
    },
  },
  {
    field: "eoyOutstandingLoanBalance",
    header: "EOY Outstanding Financing Balance",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "interestRate",
    header: "Interest Rate",
    formatter: (value: any) => `${getUSANumberFormat(Number((value ?? 0).toFixed(2)))}%`,
  },
  {
    field: "interestCharge",
    header: "Interest Charge",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
];

export const headerColumnGroupPFProjection = {
  "Plan Projections": [
    "illustratedPlanAccumulatedValue",
    "illustratedPlanSurrenderValue",
    "stressedCashValue",
    "illustratedPlanDB",
    "estimatedLoanPayoffOrIncome",
    "totalIncome",
  ],
  "": ["outsideCollateralRequirement"],
  "Financed Payments": ["lenderPremium"],
  "Financing Info": ["eoyOutstandingLoanBalance", "interestRate", "interestCharge"],
};
